import React, { useEffect, useState } from "react";
import { Field, Input } from "@fluentui/react-components";
import Ows from "../../../utils/OwsHandler";
import parsePhoneNumberFromString, { isValidPhoneNumber } from "libphonenumber-js";

const PhoneField = ({ name, label, value, error, onChange }) => {
  const [internalError, setInternalError] = useState(null);
  const [countryCode, setCountryCode] = useState("");
  const [shouldFormat, setShouldFormat] = useState(false);

  useEffect(() => {
    (async () => {
      const { response } = await Ows.handleRequest("Otys.Services.SettingsService.get", [
        { bo_client: ["country_code", "no_phone_formatting"] },
        null,
      ]);
      setCountryCode(response.bo_client.country_code);
      setShouldFormat(!response.no_phone_formatting);
    })();
  }, []);

  const formatPhone = (phone) => {
    if (!phone) return;

    const cleanedPhone = phone.startsWith("00") ? phone.slice(2) : phone;
    const phoneNumber = parsePhoneNumberFromString(cleanedPhone, { defaultCallingCode: countryCode });

    return phoneNumber ? phoneNumber.formatInternational() : phone;
  };

  const handleBlur = (e) => {
    if (shouldFormat) {
      const phone = e.target.value;
      const number = formatPhone(phone);
      onChange(number);
    }
  };

  const handleChange = (e) => {
    const phone = e.target.value;

    if (phone && !isValidPhoneNumber(phone, { defaultCallingCode: countryCode })) {
      setInternalError("Invalid phone number");
    } else {
      setInternalError(null);
    }

    onChange(name, phone);
  };

  return (
    <Field
      label={label}
      validationState={internalError || error ? "error" : "none"}
      validationMessage={internalError || error}
    >
      <Input value={value} onChange={handleChange} onBlur={handleBlur} />
    </Field>
  );
};

export default PhoneField;
